export default __webpack_public_path__ + "static/media/Group514-Yono.0b99f4a1.png";